export const BOOKING_URL = "https://outlook.office.com/bookwithme/user/c8a6ffe3a86d4f029b66d8d070b94ec7@techne.ai/meetingtype/GO9ni1yVpUKOw2mxry1zxw2?anonymous&ep=mlink";

export const CONTACT_EMAIL = "info@boardsight.ai";
